import { BinaryByteUnitPrefix } from "./BinaryByteUnitPrefix";

export class BinaryByteUnitConverter
{
  static convert( value:number, from:BinaryByteUnitPrefix, to:BinaryByteUnitPrefix )
  {
    let multiply = Math.pow( 1024, from - to );
    return value * multiply;
  }

  static fromBase( value:number, to:BinaryByteUnitPrefix )
  {
    let multiply = Math.pow( 1024, - to );
    return value * multiply;
  }

  static toBase( value:number, from:BinaryByteUnitPrefix )
  {
    let multiply = Math.pow( 1024, from );
    return value * multiply;
  }
  
} 